import React, { useEffect, useRef, useState } from "react";
import "./createTempate.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";

import ViewTemplateDetails from "./ViewTemplateDetails/ViewTemplate";
import {
  templateDateParametersOptions,
  templateMiscallenousOptions,
  templatePersonalDetailsOptions,
  templatePlanInfoOptions,
} from "../../../../../../constants";
import { useNavigate } from "react-router-dom";
export const CreateTemplate = ({
  currentSelectedRow,
  setRefreshTemplateData,
  isEdit,
  setCurrentActiveScreen,
  isFromhome,
  handleCreateTemplate,
}) => {
  const navigate = useNavigate();
  let toast = useRef();
  const [showViewTemplate, setShowViewTemplate] = useState(false);
  const formik = useFormik({
    validationSchema: Yup.object().shape({
      templateName: Yup.string().required("This is Required"),
    }),
    initialValues: {
      templateName: "",
      templateDateParametersOptions: [],
      templateMiscallenousOptions: [],
      templatePlanInfoOptions: [],
      templatePersonalDetailsOptions: [],
    },
    onSubmit: () => {
      setShowViewTemplate(true);
    },
  });
  function convertFromBackendFormat(response) {
    const values = {
      templateName: response.reportName || "",
      templateDateParametersOptions: [],
      templateMiscallenousOptions: [],
      templatePlanInfoOptions: [],
      templatePersonalDetailsOptions: [],
    };

    // Personal Details
    // Personal Details
    if (response.personalDetails?.isFirstName)
      values.templatePersonalDetailsOptions.push("firstName");
    if (response.personalDetails?.isLastName)
      values.templatePersonalDetailsOptions.push("lastName");
    if (response.personalDetails?.isMiddleName)
      values.templatePersonalDetailsOptions.push("middleName");
    if (response.personalDetails?.isSufix)
      values.templatePersonalDetailsOptions.push("suffix");
    if (response.personalDetails?.isSSN)
      values.templatePersonalDetailsOptions.push("ssn");
    if (response.personalDetails?.isDOB)
      values.templatePersonalDetailsOptions.push("dob");
    if (response.personalDetails?.isContact)
      values.templatePersonalDetailsOptions.push("contact");
    if (response.personalDetails?.isEmail)
      values.templatePersonalDetailsOptions.push("email");
    if (response.personalDetails?.isAlternateContact)
      values.templatePersonalDetailsOptions.push("alternateContact");
    if (response.personalDetails?.isAddress1)
      values.templatePersonalDetailsOptions.push("address1");
    if (response.personalDetails?.isAddress2)
      values.templatePersonalDetailsOptions.push("address2");
    if (response.personalDetails?.isZipCode)
      values.templatePersonalDetailsOptions.push("zipCode");
    if (response.personalDetails?.isMailingAddress1)
      values.templatePersonalDetailsOptions.push("mailingAddress1");
    if (response.personalDetails?.isMailingAddress2)
      values.templatePersonalDetailsOptions.push("mailingAddress2");
    if (response.personalDetails?.isCity)
      values.templatePersonalDetailsOptions.push("city");
    if (response.personalDetails?.isState)
      values.templatePersonalDetailsOptions.push("state");
    if (response.personalDetails?.isMailingCity)
      values.templatePersonalDetailsOptions.push("mailingCity");
    if (response.personalDetails?.isMailingState)
      values.templatePersonalDetailsOptions.push("mailingState");
    if (response.personalDetails?.isPoBox)
      values.templatePersonalDetailsOptions.push("poBox");
    if (response.personalDetails?.isAccountId)
      values.templatePersonalDetailsOptions.push("accountId");
    if (response.personalDetails?.isEnrollmentId)
      values.templatePersonalDetailsOptions.push("enrollmentId");

    // Dates
    // Dates
    if (response.dates?.isOrderCreateDate)
      values.templateDateParametersOptions.push("orderCreateDate");
    if (response.dates?.isApprovalDate)
      values.templateDateParametersOptions.push("approvalDate");
    if (response.dates?.isRejectDate)
      values.templateDateParametersOptions.push("rejectionDate");
    if (response.dates?.isEsnAssignDate)
      values.templateDateParametersOptions.push("esnAssignDate");
    if (response.dates?.isLabelCreateDate)
      values.templateDateParametersOptions.push("labelCreateDate");
    if (response.dates?.isInvoiceCreateDate)
      values.templateDateParametersOptions.push("invoiceCreateDate");
    if (response.dates?.isInvoiceAdjustmentDate)
      values.templateDateParametersOptions.push("invoiceAdjustmentDate");
    if (response.dates?.isInvoiceVoidedDate)
      values.templateDateParametersOptions.push("labelVoidedDate");
    if (response.dates?.isAdHocInvoiceDate)
      values.templateDateParametersOptions.push("adHocInvoiceDate");
    if (response.dates?.isLabelPrintDate)
      values.templateDateParametersOptions.push("labelPrintDate");
    if (response.dates?.isPackageDeliveredDate)
      values.templateDateParametersOptions.push("packageDeliveryDate");
    if (response.dates?.isEsnActivationDate)
      values.templateDateParametersOptions.push("esnActivationDate");
    if (response.dates?.isAccountActivationDate)
      values.templateDateParametersOptions.push("accountActivationDate");
    if (response.dates?.isPlanConfiguredDate)
      values.templateDateParametersOptions.push("planConfiguredDate");
    if (response.dates?.isPlanActivationDate)
      values.templateDateParametersOptions.push("planActivationDate");
    if (response.dates?.isPlanExpirationDate)
      values.templateDateParametersOptions.push("planExpirationDate");
    if (response.dates?.isDisconnectionDate)
      values.templateDateParametersOptions.push("disconnectionDate");
    if (response.dates?.isDisconnectionReason)
      values.templateDateParametersOptions.push("disconnectionReason");

    // Plan Info
    // Plan Info
    if (response.planInformation?.isEsnNumber)
      values.templatePlanInfoOptions.push("esnNumber");
    if (response.planInformation?.isImeiNumber)
      values.templatePlanInfoOptions.push("imei");
    if (response.planInformation?.isMdn)
      values.templatePlanInfoOptions.push("mdn");
    if (response.planInformation?.isPlanName)
      values.templatePlanInfoOptions.push("planName");
    if (response.planInformation?.isPlanCode)
      values.templatePlanInfoOptions.push("planCode");
    if (response.planInformation?.isPwgCustomerId)
      values.templatePlanInfoOptions.push("pwgCustomerId");
    if (response.planInformation?.isCarrier)
      values.templatePlanInfoOptions.push("carrier");
    if (response.planInformation?.isLineStatus)
      values.templatePlanInfoOptions.push("lineStatus");

    // Miscellaneous (copied from Plan Info)
    // Miscellaneous
    if (response.miscellaneous?.isSalesCreatedBy)
      values.templateMiscallenousOptions.push("saleCreatedBy");
    if (response.miscellaneous?.isSalesCompletedBy)
      values.templateMiscallenousOptions.push("saleCompletedBy");
    if (response.miscellaneous?.isEsnAssignedBy)
      values.templateMiscallenousOptions.push("esnAssignedBy");
    if (response.miscellaneous?.isEsnActivatedBy)
      values.templateMiscallenousOptions.push("esnActivatedBy");
    if (response.miscellaneous?.isInvoicesGeneratedBy)
      values.templateMiscallenousOptions.push("invoiceGeneratedBy");
    if (response.miscellaneous?.isInvoicePaidBy)
      values.templateMiscallenousOptions.push("invoicePaidBy");
    if (response.miscellaneous?.isInvoiceVoidedBy)
      values.templateMiscallenousOptions.push("invoiceVoidedBy");
    if (response.miscellaneous?.isInvoiceAdjustedBy)
      values.templateMiscallenousOptions.push("invoiceAdjustedBy");
    if (response.miscellaneous?.isAdHocInvoiceAddedBy)
      values.templateMiscallenousOptions.push("adHocInvoiceAddedBy");
    if (response.miscellaneous?.isLabelCreatedBy)
      values.templateMiscallenousOptions.push("labelCreatedBy");
    if (response.miscellaneous?.isLabelPrintedBy)
      values.templateMiscallenousOptions.push("labelPrintedBy");
    if (response.miscellaneous?.isPackageDeliveredBy)
      values.templateMiscallenousOptions.push("packageDeliveredBy");
    if (response.miscellaneous?.isAccountActivatedBy)
      values.templateMiscallenousOptions.push("accountActivatedBy");
    if (response.miscellaneous?.isPlanActivatedBy)
      values.templateMiscallenousOptions.push("planActivatedBy");
    if (response.miscellaneous?.isPlanConfiguredBy)
      values.templateMiscallenousOptions.push("planConfiguredBy");
    if (response.miscellaneous?.isPlanChangeBy)
      values.templateMiscallenousOptions.push("planChangedBy");
    if (response.miscellaneous?.isDisconnectedBy)
      values.templateMiscallenousOptions.push("disconnectedBy");

    return values;
  }
  useEffect(() => {
    if (isEdit) {
      const mappedValues = convertFromBackendFormat(currentSelectedRow);
      formik.setValues(mappedValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div
        style={
          !isFromhome
            ? {
                position: "fixed",
                zIndex: 1000,
                width: "100vw",
                height: "100vh",
                backgroundColor: "#FFFFFF99",
                top: 0,
                left: 0,
              }
            : undefined
        }
      ></div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
        }}
        style={{ marginTop: isEdit ? "-8.6rem" : "" }}
        id="create-template-container"
        className="create-template-container flex flex-wrap flex-row justify-content-center"
      >
        <div className="main-create-template flex flex-column ">
          <div className="top-create-template">
            <div className="create-template-header flex flex-column align-items-center justify-content-center">
              <h1 className="create-template-header-title">
                {isEdit ? "Edit" : "Create"} Template
              </h1>
              <p className="create-template-header-subtitle">
                Set your parameters below to generate tailored reports. Select
                the data points you need, and save this template for future use.
              </p>
            </div>
            <div className="create-template-form ">
              <div className="w-full">
                <div className="input-container-text">
                  <div className="w-full flex flex-wrap flex-row justify-content-between align-items-center">
                    <label>Template Name</label>
                    {formik.touched.templateName &&
                      formik.errors.templateName && (
                        <label>{formik.errors.templateName}</label>
                      )}
                  </div>
                  <input
                    className={`${formik.touched.templateName && formik.errors.templateName ? "p-invalid" : ""}`}
                    name="templateName"
                    onChange={formik.handleChange}
                    placeholder="Template Name"
                    value={formik.values.templateName}
                  />
                </div>
              </div>
              <div className="input-container ">
                <div className="w-full flex flex-wrap flex-row justify-content-between align-items-center">
                  <label>Date Parameters</label>
                  {formik.touched.templateDateParametersOptions &&
                    formik.errors.templateDateParametersOptions && (
                      <label>
                        {formik.errors.templateDateParametersOptions}
                      </label>
                    )}
                </div>
                <MultiSelect
                  options={templateDateParametersOptions}
                  className={`template-dropdown ${formik.touched.templateDateParametersOptions && formik.errors.templateDateParametersOptions ? "p-invalid" : ""}`}
                  onChange={formik.handleChange}
                  name="templateDateParametersOptions"
                  placeholder="Date Parameters"
                  value={formik.values.templateDateParametersOptions}
                />
              </div>{" "}
              <div className="input-container ">
                <div className="w-full flex flex-wrap flex-row justify-content-between align-items-center">
                  <label>Personal Details</label>
                  {formik.touched.templatePersonalDetailsOptions &&
                    formik.errors.templatePersonalDetailsOptions && (
                      <label>
                        {formik.errors.templatePersonalDetailsOptions}
                      </label>
                    )}
                </div>
                <MultiSelect
                  options={templatePersonalDetailsOptions}
                  name="templatePersonalDetailsOptions"
                  value={formik.values.templatePersonalDetailsOptions}
                  className={`template-dropdown ${formik.touched.templatePersonalDetailsOptions && formik.errors.templatePersonalDetailsOptions ? "p-invalid" : ""}`}
                  onChange={formik.handleChange}
                  placeholder="Personal Details"
                />
              </div>{" "}
              <div className="input-container ">
                <div className="w-full flex flex-wrap flex-row justify-content-between align-items-center">
                  <label>Plan Info</label>
                  {formik.touched.templatePlanInfoOptions &&
                    formik.errors.templatePlanInfoOptions && (
                      <label>{formik.errors.templatePlanInfoOptions}</label>
                    )}
                </div>
                <MultiSelect
                  options={templatePlanInfoOptions}
                  multiple
                  className={`template-dropdown ${formik.touched.templatePlanInfoOptions && formik.errors.templatePlanInfoOptions ? "p-invalid" : ""}`}
                  onChange={formik.handleChange}
                  name="templatePlanInfoOptions"
                  placeholder="Plan Info"
                  value={formik.values.templatePlanInfoOptions}
                />
              </div>{" "}
              <div className="input-container ">
                <div className="w-full flex flex-wrap flex-row justify-content-between align-items-center">
                  <label>Miscellaneous</label>
                  {formik.touched.templateMiscallenousOptions &&
                    formik.errors.templateMiscallenousOptions && (
                      <label>{formik.errors.templateMiscallenousOptions}</label>
                    )}
                </div>
                <MultiSelect
                  options={templateMiscallenousOptions}
                  className={`template-dropdown  ${formik.touched.templateMiscallenousOptions && formik.errors.templateMiscallenousOptions ? "p-invalid" : ""}`}
                  onChange={formik.handleChange}
                  name="templateMiscallenousOptions"
                  placeholder="Miscellaneous"
                  value={formik.values.templateMiscallenousOptions}
                />
              </div>{" "}
            </div>
          </div>
          <div className="action-buttons-container flex flex-wrap flex-row justify-content-end">
            <Button
              type="button"
              onClick={() => {
                if (isEdit) {
                  setCurrentActiveScreen((prev) => ({
                    ...prev,
                    isDelete: false,
                    isEdit: false,
                    isDownload: false,
                  }));
                } else {
                  if (!isFromhome) {
                    handleCreateTemplate();
                  } else {
                    navigate("/reports-downloads");
                  }
                }
              }}
              label="Back"
            />
            <Button type="submit" label="Preview" />
          </div>
        </div>

        <Toast ref={toast} />
      </form>
      {showViewTemplate && (
        <ViewTemplateDetails
          isFromhome={isFromhome}
          setRefreshTemplateData={setRefreshTemplateData}
          handleCreateTemplate={handleCreateTemplate}
          setFieldValue={formik.setFieldValue}
          isEdit={isEdit}
          currentSelectedRow={currentSelectedRow}
          setCurrentActiveScreen={setCurrentActiveScreen}
          setShowViewTemplate={setShowViewTemplate}
          values={{ ...formik.values }}
        />
      )}
    </>
  );
};
